<template>
<div class="step-two">
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="会员名称" prop="name">
      <div style="width:220px;"><el-input v-model="ruleForm.name"  placeholder="请输入会员名称"></el-input></div>
    </el-form-item>
     <el-form-item label="名称全拼" prop="enName">
      <div style="width:220px;"><el-input v-model="ruleForm.enName"  placeholder="请输名称全拼"></el-input></div>
    </el-form-item>
    <el-form-item label="身份证号码" prop="idCode">
      <div style="width:220px;"><el-input v-model="ruleForm.idCode"  placeholder="请输入身份证号码"></el-input></div>
    </el-form-item>
    <el-form-item label="会员类别" prop="radio" >
      <el-radio-group v-model="ruleForm.radio">
        <el-radio label="1"  @click.native="selectChange(1)">团体会员</el-radio>
        <el-radio label="2"  @click.native="selectChange(2)">个人会员</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="会员类型" prop="region">
      <el-select v-model="ruleForm.region" placeholder="请选择会员类型" v-if="ruleForm.radio === '1'"  @change="((val)=>{selectOp(val)})">
        <el-option
          v-for="item in ruleForm.MemberType.team"
          :key="item.id"
          :label="item.name"
          :value="item.id">{{item.name}}</el-option>
      </el-select>
      <el-select v-model="ruleForm.region" placeholder="请选择会员类型" v-if="ruleForm.radio === '2'"  @change="((val)=>{selectOp(val)})">
        <el-option
          v-for="item in ruleForm.MemberType.person"
          :key="item.id"
          :label="item.name"
          :value="item.id" >{{item.name}}</el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="年限" prop="num">
      <el-input-number v-model="ruleForm.num" :step="1" :min="1" step-strictly></el-input-number>
      <el-tooltip class="item" effect="dark" content="会员年费：50RMB/年" placement="top-start">
        <i class="el-icon-warning-outline"></i>
      </el-tooltip>
    </el-form-item>
    <el-form-item>
      <el-button @click="preEvent('ruleForm')">上一步</el-button>
      <el-button type="primary" @click="nextEvent('ruleForm')">下一步</el-button>
    </el-form-item>
  </el-form>
</div>
</template>

<script>
import { queryMemberType } from '@/api/association'

export default {
  name: 'StepOne',
  components: {
  },
  data () {
    const idCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入身份证号'))
      } else {
        var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
        // const reg = /^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$/
        if (regIdCard.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的身份证号'))
        }
      }
    }
    const checkMemberNameLetter = (rule, value, callback) => {
      var reg = /^[A-Za-z]+(\s[A-Za-z]*)*$/
      var regExp = new RegExp(reg)
      if (!regExp.test(value)) {
        callback(new Error('名称全拼应为字母'))
      } else {
        callback()
      }
    }
    return {
      parameter: {
        assoId: localStorage.getItem('assoId'),
        memberTypeId: 1
      },
      typeIds: '',
      memberType: 1,
      ruleForm: {
        name: '',
        enName: '',
        region: '',
        num: 1,
        idCode: '',
        radio: '1',
        type: [],
        MemberType: {
          person: [],
          team: []
        }
      },
      rules: {
        name: [
          { required: true, message: '请输入会员单位名称', trigger: 'blur' },
          { min: 3, message: '长度至少为3个字符', trigger: 'blur' }
        ],
        enName: [
          { required: true, validator: checkMemberNameLetter, trigger: 'blur' }
          // { min: 3, message: '长度至少为3个字符', trigger: 'blur' }
        ],
        idCode: [
          { required: true, validator: idCode, trigger: 'blur' }

        ],
        radio: [
          { required: true, message: '请会员类别', trigger: 'change' }
        ],
        region: [
          { required: true, message: '请选择会员类型', trigger: 'change' }
        ],
        num: [
          { required: true, message: '请输入申请的会员年数', trigger: 'change' }
        ]

      }
    }
  },
  methods: {
    queryMemberType () {
      queryMemberType(localStorage.getItem('assoId')).then(res => {
        if (res.data.status === 0) {
          if (res.data.data) {
            this.disclaimerExitsData = res.data.data
            this.ruleForm.MemberType = res.data.data
            // this.getDisclaimerByAssoId()
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    selectChange (num) {
      // console.log(lable)
      this.ruleForm.region = ''
      this.memberType = num
      // localStorage.setItem('memberTypeId', this.memberType)
      // this.ruleForm.radio = lable
    },
    selectOp (item) {
      console.log(item)
      this.typeIds = item
    },
    //
    nextEvent (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let memberInfo = {
            memberName: this.ruleForm.name,
            memberType: this.memberType,
            typeIds: this.typeIds,
            year: this.ruleForm.num,
            idCode: this.ruleForm.idCode,
            memberNameLetter: this.ruleForm.enName.toUpperCase()
          }
          localStorage.setItem('memberInfo', JSON.stringify(memberInfo))
          console.log(memberInfo)
          this.$emit('nextEvent', '3')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    preEvent  (formName) {
      this.$emit('nextEvent', '1')
      // this.$refs[formName].resetFields()
    },

    // 注册
    resignForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改密码
    updataForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  },
  mounted () {

  },
  created () {
    this.queryMemberType()
    // this.bg1.height = this.getHeight() + 'px'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .step-two  /deep/ .el-form-item__label{
    color: #fff;
  }
  .step-two .el-tooltip{
    margin-left: 5px;
  }
  .step-two .el-icon-warning-outline:before{
    font-size: 20px;
    color: #b41000
  }
</style>



// WEBPACK FOOTER //
// src/components/register/components/stepTwo.vue